/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixMessageEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_MESSAGE_EVENT_ENTITY_NAME = 'exc.route.v1.FixMessageEvent';
export const excRouteV1FixMessageEventEntity = new schema.Entity<ExcRouteV1FixMessageEvent>(EXC_ROUTE_V1_FIX_MESSAGE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcRouteV1FixMessageEvent) => `${entity.metadata?.eventId}` });

